import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\t\t\tdisplay: inline-flex;\n\t\t\t\t\t\topacity: 0.5;\n\t\t\t\t\t"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\t\t\t\t\tcursor: pointer;\n\t\t\t\t\tpadding-left: ", ";\n\t\t\t\t\tpadding-right: ", ";\n\t\t\t\t\tvertical-align: middle;\n\t\t\t\t"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { help as helpIcon } from '@wordpress/icons';
import { contextConnect, useContextSystem } from '@wp-g2/context';
import { css, ui } from '@wp-g2/styles';
import React from 'react';
import { Icon } from '../Icon';
import { Tooltip } from '../Tooltip';
import { View } from '../View';

function HelpTip(props, forwardedRef) {
  var _useContextSystem = useContextSystem(props, 'HelpTip'),
      as = _useContextSystem.as,
      children = _useContextSystem.children,
      _useContextSystem$ico = _useContextSystem.iconSize,
      iconSize = _useContextSystem$ico === void 0 ? 14 : _useContextSystem$ico,
      otherProps = _objectWithoutProperties(_useContextSystem, ["as", "children", "iconSize"]);

  var handleOnClick = React.useCallback(function (event) {
    event.preventDefault();
  }, []);
  return /*#__PURE__*/React.createElement(Tooltip, Object.assign({}, otherProps, {
    content: children,
    ref: forwardedRef
  }), /*#__PURE__*/React.createElement(View, {
    as: as || 'span',
    css: css(_templateObject(), ui.space(1), ui.space(1)),
    onClick: handleOnClick
  }, /*#__PURE__*/React.createElement(Icon, {
    css: css(_templateObject2()),
    fill: ui.get('colorText'),
    icon: helpIcon,
    size: iconSize
  })));
}

export default contextConnect(HelpTip, 'HelpTip');